module.exports = __webpack_public_path__ + "assets/img/fcca-mp.svg";